"use strict";

var cov_dronycghp = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\FootnoteObject.js";
  var hash = "155ee936c83f5c5813496d8868affe84f2a5d6be";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\FootnoteObject.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "1": {
        start: {
          line: 14,
          column: 34
        },
        end: {
          line: 14,
          column: 54
        }
      },
      "2": {
        start: {
          line: 16,
          column: 21
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 37
        }
      },
      "4": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "5": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 22
        }
      },
      "6": {
        start: {
          line: 24,
          column: 15
        },
        end: {
          line: 24,
          column: 32
        }
      },
      "7": {
        start: {
          line: 25,
          column: 13
        },
        end: {
          line: 25,
          column: 48
        }
      },
      "8": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 58,
          column: 4
        }
      },
      "9": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 67,
          column: 2
        }
      },
      "10": {
        start: {
          line: 69,
          column: 18
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "11": {
        start: {
          line: 69,
          column: 39
        },
        end: {
          line: 78,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "FootnoteObject",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 23
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 21
          },
          end: {
            line: 16,
            column: 22
          }
        },
        loc: {
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 20,
            column: 23
          }
        },
        loc: {
          start: {
            line: 20,
            column: 28
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 69,
            column: 29
          },
          end: {
            line: 69,
            column: 30
          }
        },
        loc: {
          start: {
            line: 69,
            column: 39
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 69
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 36
          }
        }, {
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 48
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "155ee936c83f5c5813496d8868affe84f2a5d6be"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function FootnoteObject(_ref) {
  var verseObject = _ref.verseObject;
  cov_dronycghp.f[0]++;
  var classes = (cov_dronycghp.s[0]++, useStyles());

  var _ref2 = (cov_dronycghp.s[1]++, _react.default.useState(null)),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      anchorEl = _ref3[0],
      setAnchorEl = _ref3[1];

  cov_dronycghp.s[2]++;

  var handleOpen = function handleOpen(event) {
    cov_dronycghp.f[1]++;
    cov_dronycghp.s[3]++;
    setAnchorEl(event.currentTarget);
  };

  cov_dronycghp.s[4]++;

  var handleClose = function handleClose() {
    cov_dronycghp.f[2]++;
    cov_dronycghp.s[5]++;
    setAnchorEl(null);
  };

  var open = (cov_dronycghp.s[6]++, Boolean(anchorEl));
  var id = (cov_dronycghp.s[7]++, open ? (cov_dronycghp.b[0][0]++, 'simple-popover') : (cov_dronycghp.b[0][1]++, undefined));
  cov_dronycghp.s[8]++;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_core.Badge, {
    className: classes.badge,
    badgeContent: "fn",
    color: "primary",
    "aria-describedby": id,
    variant: "standard",
    onClick: handleOpen
  }, _react.default.createElement("span", null, "\xA0")), _react.default.createElement(_core.Popover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, _react.default.createElement(_core.Typography, {
    className: classes.footnote
  }, verseObject.content)));
}

;
cov_dronycghp.s[9]++;
FootnoteObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string
  }).isRequired
};
var useStyles = (cov_dronycghp.s[10]++, (0, _styles.makeStyles)(function (theme) {
  cov_dronycghp.f[3]++;
  cov_dronycghp.s[11]++;
  return {
    footnote: {
      padding: theme.spacing(1)
    },
    badge: {
      margin: theme.spacing(1),
      top: theme.spacing(1),
      right: theme.spacing(0.25)
    }
  };
}));
var _default = FootnoteObject;
exports.default = _default;